import { useProfile } from '@mint-lib/profile-helpers';
import { useMdmPlatforms } from '@mint-lib/routing-context';
import { getRouteApi } from '@mint/routing';

import type { ConnectionPlatformDisplay } from '../types.js';

const connectionsRouteApi = getRouteApi(
  '/_secured/external-data/integrations/$integration/connections',
);

/**
 * Resolves the current `$integration` route param to its MDM `platform_v2`
 * metadata (label, logo, ...) for the shared connection UI.
 */
export const useConnectionPlatform = (): ConnectionPlatformDisplay => {
  const { integration } = connectionsRouteApi.useParams();
  const { profile } = useProfile();

  const { platformByLabel } = useMdmPlatforms({
    companyId: profile?.profile?.company?.id,
    onlyOmni: true,
  });

  return platformByLabel?.[integration];
};
